import styled, { css } from 'styled-components';
import Select from 'react-select';
import { colors, radii } from '@gbs-monorepo-packages/styles';
import { IMultiSelectOptions } from '@gbs-monorepo-packages/common';

type IMultiSelectLabelOptions = {
  active: boolean;
};

export const Container = styled.div`
  margin-bottom: 0.75rem;
`;

export const ContainerSelect = styled.div`
  position: relative;
`;

export const StyledLabel = styled.label<IMultiSelectLabelOptions>`
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: ${colors.gray300};
  font-size: 1rem;
  transition: all 0.2s ease-out;
  background: ${colors.white300};
  padding: 0 4px;
  z-index: 1;

  ${({ active }) =>
    active
      ? css`
          top: 0;
          transform: translateY(-0.5rem);
          font-size: 0.75rem;
          color: ${colors.blue250};
        `
      : css`
          display: none;
        `}
`;

export const StyledSelect = styled(Select<IMultiSelectOptions, true>)<{ menuZIndex?: number }>`
  .select__control {
    border: 1px solid ${colors.gray200};
    border-radius: ${radii.xs};
    box-shadow: none;
    min-height: 48px !important;
    padding: 8px 0 4px 8px;
    font-size: 1rem;
    transition: border-color 0.2s;
    cursor: pointer;

    &:hover {
      border-color: ${colors.gray250};
    }

    &--menu-is-open {
      border-color: ${colors.blue250} !important;
    }
  }
  .select__multi-value,
  .select__multi-value__label,
  .select__multi-value__remove {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }

  .select__menu {
    scrollbar-width: thin;
    scrollbar-color: ${colors.gray200} transparent;
    z-index: 10;
  }

  .select__menu::-webkit-scrollbar {
    width: 8px;
  }

  .select__menu::-webkit-scrollbar-track {
    background: transparent;
  }

  .select__menu::-webkit-scrollbar-thumb {
    background-color: ${colors.gray200};
    border-radius: 4px;
  }

  .select__option {
    overflow: hidden;
  }
`;

export const OptionLabel = styled.span`
  display: block;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
`;

export const ErrorMessage = styled.div`
  color: ${colors.red300};
  font-size: 0.7rem;
  margin-top: ${radii.xs};
`;
